import styled from 'styled-components';

export default styled.span`
    border-right: 1px solid ${props => props.theme.palette.blueGrey[500]};
    margin: 0 ${props => props.theme.space[4]};
`;



// WEBPACK FOOTER //
// ./src/components/styles/VerticalDivider.js